import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/end-user/")({
  beforeLoad: () => {
    throw redirect({ to: "/end-user/dashboard", replace: true });
  },
});
